import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/service/alert.service';
import { LicencasService } from 'src/app/service/licencas.service';
import { ProdutosService } from 'src/app/service/produtos.service';

@Component({
  selector: 'app-cadastrar-licenca',
  templateUrl: './cadastrar-licenca.component.html',
  styleUrls: ['./cadastrar-licenca.component.css'],
})
export class CadastrarLicencaComponent implements OnInit {
  public licencaForm: FormGroup = this.formBuilder.group({
    fk_produto: ['', Validators.required],
    fl_valor: ['', Validators.required],
    vc_nome: ['', Validators.required],
    camposAdicionais: this.formBuilder.array([
      this.formBuilder.group({
        vc_campo: [''],
        bl_pertence_token: [false],
      }),
    ]),
  });
  public produtos: any = [];

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private produtoService: ProdutosService,
    private licencaService: LicencasService,
    private alertService: AlertService
  ) {}

  ngOnInit(): void {
    this.listarProdutos();
  }

  get camposAdicionais() {
    return this.licencaForm.get('camposAdicionais') as FormArray;
  }

  cancel() {
    this.router.navigate(['configuracao/licencas']);
  }

  adicionarCampo() {
    this.camposAdicionais.push(
      this.formBuilder.group({
        vc_campo: [''],
        bl_pertence_token: [false],
      })
    );
  }

  removerCampo(index: any) {
    this.camposAdicionais.removeAt(index);
  }

  cadastrar() {
    this.licencaService.cadastrarLicenca(this.licencaForm.value).subscribe(
      (licenca: any) => {
        this.alertService.success();
        this.router.navigate(['configuracao/licencas']);
      },
      (erro) => {
        this.alertService.error(erro);
      }
    );
  }

  listarProdutos() {
    this.produtoService.listarService().subscribe((resp: any) => {
      this.produtos = resp.filter(function (elem: any) {
        return elem.sr_id != 1;
      });
    });
  }
}
